import React from 'react';
import { useIntl } from 'ha/i18n';
import BreadcrumbsNext from 'ha/components/next/Breadcrumbs';
import { useRequiredHermes } from 'ha/modules/Hermes';
import { notEmpty } from 'ha/utils/notEmpty';
import BlogTypes from 'ha/constants/BlogTypes';

import { HermesData } from '../types';

const CommunityBreadcrumbs: React.FC = () => {
  const { T, urlResolver } = useIntl();
  const {
    data: { type, country },
    route,
  } = useRequiredHermes<HermesData>();
  const breadcrumbs = [
    type === BlogTypes.ADVERTISER && country
      ? {
          name: country.name,
          path: country.hasData
            ? urlResolver.absolutizePath(country.pathname, {
                skipAddLanguage: true,
              })
            : undefined,
          dataTestLocator: 'CommunityBreadcrumb Country',
        }
      : null,
    {
      name: type === BlogTypes.ADVERTISER ? T('Advertisers') : T('Community'),
      path: urlResolver.absolutizePath(route.pathname, {
        skipAddLanguage: true,
      }),
      dataTestLocator: 'CommunityBreadcrumb City',
    },
  ].filter(notEmpty);

  return <BreadcrumbsNext breadcrumbs={breadcrumbs} />;
};

export default CommunityBreadcrumbs;
